import { CoreFormFieldTextArea } from '../fields/CoreFormFieldTextArea';
import { FormFieldContainer } from '../layout/FormFieldContainer';
import type { ContextFormFieldBaseProps } from './ContextFormFieldBaseProps';
import type { FormFieldControllerRulesProps } from './FormFieldController';
import { FormFieldController } from './FormFieldController';

export const ContextFormFieldTextArea = ({
  fieldPath,
  rules,
  disabled,
  label,
  inline,
  placeholder,
  helperText,
  colSpan,
}: ContextFormFieldBaseProps) => {
  return (
    <FormFieldController
      name={fieldPath}
      rules={rules as FormFieldControllerRulesProps}
    >
      {({ field, fieldState }) => (
        <FormFieldContainer colSpan={colSpan}>
          <CoreFormFieldTextArea
            label={rules?.required ? `${label} *` : label}
            error={fieldState.error?.message?.toString()}
            inputProps={{
              id: fieldPath,
              ...field,
              onChange: field.onChange,
              disabled,
              placeholder,
              'data-testid': fieldPath,
              rows: 3,
            }}
            inline={inline}
            helperText={helperText}
          />
        </FormFieldContainer>
      )}
    </FormFieldController>
  );
};
